import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { get } from 'lodash';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { downloadGeneratedAnswerSheet as downloadGeneratedAnswerSheetAction } from 'legacy/src/actions/paperscorer';
import './index.scss';

const DownloadNowLink = ({
  downloadGeneratedAnswerSheet,
  loadingGeneratedAnswersheet,
  payload,
}) => (
  <Fragment>
    <a
      className="text-blue-500 font-bold"
      onClick={() => downloadGeneratedAnswerSheet(payload)}
    >
      Download now
    </a>
    {loadingGeneratedAnswersheet && (
      <div className="DownloadNowLink__loading-spinner-container">
        <LoadingSpinner containerClassName="DownloadNowLink__loading-spinner" />
      </div>
    )}
  </Fragment>
);

const mapStateToProps = (state) => ({
  assignmentId: get(state, 'teacherAssignment.assignment.id'),
  loadingGeneratedAnswersheet: get(
    state,
    'paperscorer.loadingGeneratedAnswersheet',
  ),
});

const mapDispatchToProps = {
  downloadGeneratedAnswerSheet: downloadGeneratedAnswerSheetAction,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  DownloadNowLink,
);
